<template>
  <div :class="[`${CLS_PRE}-breadcrumb`]">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { provide, reactive, toRef, defineComponent } from 'vue';

import {
  COMP_NAME,
  CLS_PRE,
  EMITS_DEC,
  PROPS_DES,
  PROVIDE_KEY
} from './config';

export default defineComponent({
  name: COMP_NAME,

  emits: EMITS_DEC,

  props: PROPS_DES,
  setup(props, { expose }) {
    provide(
      PROVIDE_KEY,
      reactive({
        separator: toRef(props, 'separator')
      })
    );

    // 在使用其它组件过程中，发现TS只能识别return中返回的数据，暂时做此处理。
    const exposeTemp = {
    };
    expose(exposeTemp);

    return {
      CLS_PRE,
      ...exposeTemp
    };
  }
});
</script>

<style lang="scss" src="./css/index.scss" scoped></style>
